
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import FileUploader from '@/components/FileUploader.vue';
    import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
    import {
        FileModel,
        PersonalInfoActions,
        PersonalInfoClient,
        PersonalInfoModel, ResultError, UpdatePersonalInfoRequest,
    } from "@/api-client";
    import {Prop} from "vue-property-decorator";
    import Files from "@/components/Files.vue";
    import PersonMainInfo from "@/features/personProfile/views/PersonMainInfo.vue";
    import ImageUploader from "@/components/ImageUploader.vue";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";
    import PopoverInfo from '@/components/PopoverInfo.vue';
    import Loader from "@/features/shared/components/Loader";
    import toasts from "@/components/Toasts";
    import SignatureModal from "@/features/personProfile/components/SignatureModal.vue"

    @Component({
        components: {
            Files,
            FileUploader,
            HeadingGroup,
            ImageUploader,
            LabelOptional,
            PersonMainInfo,
            PopoverInfo,
            SignatureModal
        },
    })
    export default class PersonFiles extends Vue {

        @Prop({required: true})
        validationErrors!: ResultError;
        
        @Prop({required: true})
        model!: PersonalInfoModel;

        @Prop({required: true})
        updateModel!: UpdatePersonalInfoRequest;

        @Prop({required: true})
        isInfoLocked!: boolean;

        @Prop({required: true})
        availableActions!: PersonalInfoActions;

        @Prop({default: () => new Loader()})
        fileLoader!: Loader;
        
        signaturePadFile: File | null = null;
        
        get canUserEditImages(){
            return !this.isInfoLocked && this.availableActions.canUpdatePersonalInfo;
        }

        canChooseLastAsActiveProfileImage(images: FileModel[]): boolean {
            return this.availableActions.canChooseActiveProfileImage
                && images.length > 0
                && this.model.activeProfileImageId !== images.last().id;
        }

        isLastChosenAsActiveProfileImage(images: FileModel[]): boolean {
            return this.availableActions.canChooseActiveProfileImage
                && images.length > 0
                && this.model.activeProfileImageId === images.last().id;
        }
        
        async chooseActiveProfileImage(imageId: string){
            await new PersonalInfoClient().chooseActiveProfileImage(this.$route.params.seafarerId, imageId).then(
                () => {
                    this.model.activeProfileImageId = imageId;
                    toasts.success("Dokumendifoto valitud");
                },
                (error: ResultError) => error.messagesFlattened.forEach(x => toasts.failure(x)));
        }

        async getDownloadUrl(fileId: string): Promise<string> {
            return (await new PersonalInfoClient().downloadFile(fileId, this.$route.params.seafarerId)).url;
        }

        uploadNewSignatureImage(){
            this.model.signatureImages = [];
        }

        uploadSignature(file: File){
            this.uploadNewSignatureImage();
            this.signaturePadFile = file;
        }

        uploadNewCustomProfileImage(event: Event){
            event.preventDefault(); // Prevent from selecting custom image as displayed profile image.
            this.model.customProfileImages = [];
        }
    }
